import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src="https://public.readdy.ai/ai/img_res/aa1c1a86-9872-4cff-b8d1-11c484be4ea5.png"
              alt="Joel Painting Logo"
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[15px] font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#1A2B4A]'
                    : 'text-[#6B7280] hover:text-[#1A2B4A]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Phone & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:+12695551234"
              className="text-[#1A2B4A] font-semibold text-[16px] hover:text-[#3B82F6] transition-colors whitespace-nowrap"
            >
              (269) 555-1234
            </a>
            <Link
              to="/contact"
              className="bg-[#1A2B4A] text-white px-6 py-3 rounded-lg font-medium text-[15px] hover:bg-[#2A3B5A] transition-colors whitespace-nowrap"
            >
              Free Estimate
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-[#1A2B4A]"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 text-[15px] font-medium ${
                  location.pathname === link.path
                    ? 'text-[#1A2B4A]'
                    : 'text-[#6B7280]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:+12695551234"
              className="block py-2 text-[#1A2B4A] font-semibold text-[15px]"
            >
              <i className="ri-phone-line mr-2"></i>
              (269) 555-1234
            </a>
            <Link
              to="/contact"
              className="block text-center bg-[#1A2B4A] text-white px-6 py-3 rounded-lg font-medium text-[15px] whitespace-nowrap"
            >
              Free Estimate
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;